import React from "react";
import ActionButton from "components/ActionButton";
import { ACTIVATION_TYPES } from "utils/constants";
import { Link, useLocation } from "react-router-dom";
import MyCustomTable from "components/MyCustomTable";
import { activationStates } from "../../../variables/activations";
import ActivationStatusChip from "components/ActivationStatusChip";

const PendingActivations = () => {
    const location = useLocation();

    const columns = React.useMemo(
        () => [
            {
                accessorFn: (row) => row.code,
                accessorKey: "code",
                header: () => <span className="text-gray-400">NUMERO</span>,
                enableResizing: false,
                enableSorting: false,
                footer: (props) => props.column.id,
                cell: (props) => {
                    return (
                        <div
                            className="bottom-10 right-10 z-10"
                            style={{
                                textOverflow: "ellipsis",
                                overflow: "auto",
                            }}
                        >
                            <p className="table-cell text-sm text-blue-600 md:hidden">
                                <Link
                                    to={{
                                        pathname: `/my/${
                                            props?.row?.original?.status ===
                                                activationStates.PENDING_COMPLETION ||
                                            props?.row?.original?.status ===
                                                activationStates.WAITING_FOR_SERVER_CODE
                                                ? props?.row?.original?.type.toLowerCase() ===
                                                  ACTIVATION_TYPES.ONSITE
                                                    ? "activation-onsite"
                                                    : "activation-cloud"
                                                : "activation-details"
                                        }/${props?.row?.original?.params}`,
                                    }}
                                    className="hover:text-blue-500 dark:hover:text-white"
                                >
                                    {props?.row?.original?.params}
                                </Link>
                            </p>
                            <p className="hidden md:table-cell">
                                {props.cell.getValue()}
                            </p>
                        </div>
                    );
                },
            },
            {
                accessorFn: (row) => row.name,
                accessorKey: "name",
                enableSorting: false,
                header: () => (
                    <>
                        <span className="table-cell text-gray-400 md:hidden">
                            INFORMAZIONI
                        </span>
                        <span className="hidden text-gray-400 md:table-cell">
                            CLIENTE
                        </span>
                    </>
                ),
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <span className="table-cell md:hidden">
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.name}
                            </p>
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.type}
                            </p>
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.fqdn}
                            </p>
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.created_at}
                            </p>
                        </span>
                        <p className="hidden text-sm text-gray-800 dark:text-white md:table-cell">
                            {props.cell.getValue()?.toString()}
                        </p>
                    </div>
                ),
            },
            {
                accessorFn: (row) => row.type,
                accessorKey: "type",
                enableSorting: false,
                header: () => <span className="text-gray-400">TIPOLOGIA</span>,
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <span>
                            <p className="text-sm text-gray-800 dark:text-white">
                                {props.cell.getValue()?.toString()}
                            </p>
                        </span>
                    </div>
                ),
                meta: { columnClasses: "hidden md:table-cell" },
            },
            {
                accessorFn: (row) => row.fqdn,
                accessorKey: "fqdn",
                enableSorting: false,
                header: () => <span className="text-gray-400">FQDN</span>,
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <span>
                            <p className="text-sm text-gray-800 dark:text-white">
                                {props.cell.getValue()?.toString()}
                            </p>
                        </span>
                    </div>
                ),
                meta: { columnClasses: "hidden md:table-cell" },
            },
            {
                accessorFn: (row) => row.created_at,
                accessorKey: "created_at",
                enableSorting: false,
                header: () => <span className="text-gray-400">DATA</span>,
                footer: (props) => props.column.id,
                cell: (props) => {
                    return (
                        <div
                            className="bottom-10 right-10 z-10"
                            style={{
                                textOverflow: "ellipsis",
                                overflow: "auto",
                            }}
                        >
                            <span>
                                <p className="text-sm text-gray-800 dark:text-white">
                                    {props.cell.getValue()?.toString()}
                                </p>
                            </span>
                        </div>
                    );
                },
                meta: { columnClasses: "hidden md:table-cell" },
            },
            {
                accessorFn: (row) => row.status,
                accessorKey: "status",
                enableSorting: false,
                header: () => <span className="text-gray-400">STATO</span>,
                footer: (props) => props.column.id,
                cell: (props) => {
                    let cellValue = props.cell.getValue()?.toString();

                    return <ActivationStatusChip value={cellValue} />;
                },
            },
            {
                accessorFn: (row) => row.params,
                accessorKey: "params",
                enableSorting: false,
                header: (props) => {
                    return <span className="text-gray-400">Azioni</span>;
                },
                footer: (props) => props.column.id,
                cell: (props) => {
                    return (
                        <ActionButton
                            to={{
                                pathname: `/my/${
                                    props?.row?.original?.status ===
                                        activationStates.PENDING_COMPLETION ||
                                    props?.row?.original?.status ===
                                        activationStates.WAITING_FOR_SERVER_CODE
                                        ? props?.row?.original?.type.toLowerCase() ===
                                          ACTIVATION_TYPES.ONSITE
                                            ? "activation-onsite"
                                            : "activation-cloud"
                                        : "activation-details"
                                }/${props?.cell?.getValue()?.toString()}`,
                            }}
                            state={{ from: location.pathname }}
                            text={`${
                                props?.row?.original?.status ===
                                    activationStates.PENDING_COMPLETION ||
                                props?.row?.original?.status ===
                                    activationStates.WAITING_FOR_SERVER_CODE
                                    ? "riprendi"
                                    : "dettagli"
                            }`}
                            isOutlined={
                                props?.row?.original?.status !==
                                    activationStates.PENDING_COMPLETION &&
                                props?.row?.original?.status !==
                                    activationStates.WAITING_FOR_SERVER_CODE
                            }
                        />
                    );
                },
                meta: { columnClasses: "hidden md:table-cell" },
            },
        ],
        []
    );

    return (
        <MyCustomTable
            columns={columns}
            endpoint={"/activation/pending"}
            title={"Attivazioni in sospeso"}
            description={
                <div className="flex flex-col gap-3">
                    <p>
                        Sei nella sezione Attivazioni in sospeso. <br />
                        Qui, sono elencate le richieste di attivazione non
                        ancora completate.
                    </p>
                    <p>
                        Puoi visualizzare il numero di attivazione, il cliente,
                        la tipologia, l’FQDN, la data di inserimento e lo stato
                        per ciascuna richiesta.
                    </p>
                    <p>
                        Se lo stato è{" "}
                        <strong>
                            <i>In approvazione</i>
                        </strong>
                        , la richiesta è stata inviata in modo corretto ed è in
                        fase di verifica. Una volta approvata, l’attivazione
                        proseguirà in automatico.
                        <br />
                        Vuoi saperne di più? Clicca su{" "}
                        <strong>
                            <i>Dettagli</i>{" "}
                        </strong>
                        per consultare tutte le informazioni della richiesta e
                        verificare eventuali dati mancanti.
                    </p>
                </div>
            }
        />
    );
};

export default PendingActivations;
